// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --citibanamex-core-b-2: var(--blue-200);
}

/* --citibanamex-core-b-2 var(--citibanamex-core-b-2): #0062b3; */
app-modal-basic {
  display: none;
}
app-modal-basic .modal-basic {
  pointer-events: auto;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 30, 34, 0.6);
  z-index: 4;
  justify-content: center;
  align-items: center;
  text-align: center;
  display: flex;
}
app-modal-basic .modal-basic > .content {
  border-radius: 12px;
  pointer-events: auto;
  background-color: white;
  position: relative;
  z-index: 3;
  margin: 0 8px;
  flex-flow: column;
  display: inline-block;
  vertical-align: middle;
  min-width: 348px;
}
app-modal-basic .modal-basic > .content.-buttons {
  padding: 32px 32px 40px;
  margin-right: 16px;
  margin-left: 16px;
}
app-modal-basic .modal-basic > .content.-size-modal {
  width: 323px;
  padding: 0;
  padding: 20px 32px 0;
  width: 886px;
  padding: 20px 32px 34px;
}
app-modal-basic .modal-basic > .content .icon-modal {
  width: 24px;
  height: 24px;
  margin-top: 10px;
  margin-bottom: 23px;
  margin-left: 15px;
  font-size: 24px;
}
app-modal-basic .modal-basic > .content > .actions {
  width: 100%;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: flex-end;
  position: relative;
}
app-modal-basic .modal-basic > .content > .actions > .iconclose {
  cursor: pointer;
  color: #056dae;
  font-size: 24px;
}
app-modal-basic .modal-basic > .content .containerButtons {
  display: flex;
  flex-direction: row;
  flex-wrap: inherit;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 13px 16px;
  border-top: 1px solid #d3daea;
  gap: 4px;
}
app-modal-basic .modal-basic > .content .containerButtons .btn {
  cursor: pointer;
}
app-modal-basic .modal-basic > .content .containerButtons .bold-font {
  font-weight: bold;
}
app-modal-basic .modal-basic > .content .containerButtons .width-btn {
  width: 48%;
}
app-modal-basic .modal-basic > .content .containerButtons .inactive {
  color: #acb2bf;
  cursor: default;
}
app-modal-basic .notification-information-circle:before {
  content: "\\f0af";
}
app-modal-basic .tamaño-circulo {
  font-size: 24px;
}

.modal-form {
  align-items: flex-start;
}
.modal-form > .content {
  padding: 40px;
  width: 600px;
}

body.modal-open {
  overflow: hidden;
}

.containerModal {
  max-width: 348px;
  text-align: left;
  position: relative;
  width: 100%;
  padding: 0 16px;
  height: 160px;
}

.containerMode {
  max-width: 348px !important;
  line-height: 24px;
}

.textModal {
  margin-bottom: 20px;
}

.textModals {
  margin: 16px 0;
  display: inline;
}

.tituloModal {
  margin-bottom: 10px;
}

.schedule-stopwatch:before {
  content: "\\f120" !important;
}`, "",{"version":3,"sources":["webpack://./projects/dashboard-new/src/app/components/modal-basic/modal-basic.component.scss","webpack://./projects/dashboard-new/public/assets/css/_color-palette.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EAEA,uCAAA;ADCA;;ACIA,iEAAA;ADLA;EACE,aAAA;AAKF;AAHE;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,gCAAA;EACA,UAAA;EAEA,uBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,aAAA;AAKJ;AAHI;EACE,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EAEA,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;AAKN;AAHM;EACE,uBAAA;EACA,kBAAA;EACA,iBAAA;AAKR;AAFM;EACE,YAAA;EACA,UAAA;EACA,oBAAA;EAEA,YAAA;EACA,uBAAA;AAGR;AAAM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAER;AACM;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AACR;AACQ;EACE,eAAA;EAEA,cAAA;EACA,eAAA;AAAV;AAIM;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,QAAA;AAFR;AAIQ;EACE,eAAA;AAFV;AAKQ;EACE,iBAAA;AAHV;AAMQ;EACE,UAAA;AAJV;AAOQ;EACE,cAAA;EACA,eAAA;AALV;AAWE;EACE,gBAAA;AATJ;AAYE;EACE,eAAA;AAVJ;;AAcA;EACE,uBAAA;AAXF;AAaE;EACE,aAAA;EAEA,YAAA;AAZJ;;AAgBA;EACE,gBAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;AAbF;;AAgBA;EACE,2BAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAgBA;EACE,cAAA;EACA,eAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAgBA;EACE,2BAAA;AAbF","sourcesContent":["@use '../../../../public/assets/css/variables.scss';\r\n\r\napp-modal-basic {\r\n  display: none;\r\n\r\n  .modal-basic {\r\n    pointer-events: auto;\r\n    width: 100%;\r\n    height: 100%;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    background: rgba(0, 30, 34, 0.6);\r\n    z-index: 4;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    display: flex;\r\n\r\n    > .content {\r\n      border-radius: 12px;\r\n      pointer-events: auto;\r\n      background-color: white;\r\n      position: relative;\r\n      z-index: 3;\r\n      margin: 0 8px;\r\n      -ms-flex-flow: column;\r\n      flex-flow: column;\r\n      display: inline-block;\r\n      vertical-align: middle;\r\n      min-width: 348px;\r\n\r\n      &.-buttons {\r\n        padding: 32px 32px 40px;\r\n        margin-right: 16px;\r\n        margin-left: 16px;\r\n      }\r\n\r\n      &.-size-modal {\r\n        width: 323px;\r\n        padding: 0;\r\n        padding: 20px 32px 0;\r\n\r\n        width: 886px;\r\n        padding: 20px 32px 34px;\r\n      }\r\n\r\n      .icon-modal {\r\n        width: 24px;\r\n        height: 24px;\r\n        margin-top: 10px;\r\n        margin-bottom: 23px;\r\n        margin-left: 15px;\r\n        font-size: 24px;\r\n      }\r\n\r\n      > .actions {\r\n        width: 100%;\r\n        display: flex;\r\n        flex-flow: row;\r\n        align-items: center;\r\n        justify-content: flex-end;\r\n        position: relative;\r\n\r\n        > .iconclose {\r\n          cursor: pointer;\r\n          // color: cbmx-color($palette, allports);\r\n          color: #056dae;\r\n          font-size: 24px;\r\n        }\r\n      }\r\n\r\n      .containerButtons {\r\n        display: flex;\r\n        flex-direction: row;\r\n        flex-wrap: inherit;\r\n        justify-content: space-around;\r\n        align-items: center;\r\n        position: absolute;\r\n        bottom: 0;\r\n        width: 100%;\r\n        padding: 13px 16px;\r\n        border-top: 1px solid #d3daea;\r\n        gap: 4px;\r\n\r\n        .btn {\r\n          cursor: pointer;\r\n        }\r\n\r\n        .bold-font {\r\n          font-weight: bold;\r\n        }\r\n\r\n        .width-btn {\r\n          width: 48%;\r\n        }\r\n\r\n        .inactive {\r\n          color: #acb2bf;\r\n          cursor: default;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .notification-information-circle:before {\r\n    content: '\\F0AF';\r\n  }\r\n\r\n  .tamaño-circulo {\r\n    font-size: 24px;\r\n  }\r\n}\r\n\r\n.modal-form {\r\n  align-items: flex-start;\r\n\r\n  > .content {\r\n    padding: 40px;\r\n\r\n    width: 600px;\r\n  }\r\n}\r\n\r\nbody.modal-open {\r\n  overflow: hidden;\r\n}\r\n\r\n.containerModal {\r\n  max-width: 348px;\r\n  text-align: left;\r\n  position: relative;\r\n  width: 100%;\r\n  padding: 0 16px;\r\n  height: 160px;\r\n}\r\n\r\n.containerMode {\r\n  max-width: 348px !important;\r\n  line-height: 24px;\r\n}\r\n\r\n.textModal {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.textModals {\r\n  margin: 16px 0;\r\n  display: inline;\r\n}\r\n\r\n.tituloModal {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.schedule-stopwatch:before {\r\n  content: '\\F120' !important;\r\n}\r\n",":root{\r\n\r\n--citibanamex-core-b-2: var(--blue-200);\r\n\r\n}\r\n\r\n$citibanamex-core-b-1: #17294d;\r\n/* --citibanamex-core-b-2 var(--citibanamex-core-b-2): #0062b3; */\r\n$citibanamex-core-b-3: #3db6f2;\r\n$citibanamex-core-r-1: #ed1c24;\r\n$digital-core-b-2-50: #e6f7ff;\r\n$digital-core-b-2-100: #aad2f2;\r\n$digital-core-b-2-200: #62b1d9;\r\n$digital-core-b-2-700: #00528c;\r\n$digital-core-b-2-900: #143666;\r\n$digital-core-black: #000;\r\n$digital-core-dark-gray: #5c5f66;\r\n$digital-core-fuchsia: #c6007e;\r\n$digital-core-fuchsia-50: #ffe6f7;\r\n$digital-core-gray: #8a8f99;\r\n$digital-core-information: #0062b3;\r\n$digital-core-light-gray: #d3daea;\r\n$digital-core-medium-gray: #939DA1;\r\n$digital-core-near-white: #f5f7fc;\r\n$digital-core-r-1-50: #ffe6e6;\r\n$digital-core-r-1-100: #fcd9d9;\r\n$digital-core-r-1-700: #c00;\r\n$digital-core-r-1-900: #900;\r\n$digital-core-slate-gray: #001E22;\r\n$digital-core-success: #093;\r\n$digital-core-success-50: #f4fff2;\r\n$digital-core-success-100: #dfffd9;\r\n$digital-core-success-700: #062;\r\n$digital-core-teal: #007377;\r\n$digital-core-teal-50: #e6ffff;\r\n$digital-core-ultra-light-gray: #f8f8f8;\r\n$digital-core-warning: #ff8c19;\r\n$digital-core-warning-50: #fff9d9;\r\n$digital-core-warning-900: #b35900;\r\n$digital-core-white: #fff;\r\n$digital-core-yellow-100: #fff2d9;\r\n$products-afore: #0b94d9;\r\n$products-ahorro-facil: #ff8080;\r\n$products-fondos-de-inversion: #0099e6;\r\n$products-gold: #998847;\r\n$products-hipotecario: #581466;\r\n$products-home-depot: #e57200;\r\n$products-la-verde: #004d2f;\r\n$products-nomina: #062;\r\n$products-patrimonial: #b4975a;\r\n$products-priority: #0e2a48;\r\n$products-rewards: #065c77;\r\n$products-telet-n: #653279;\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
